import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
    footerBox: {
        background: 'transparent linear-gradient(270deg, #43425D 0%, #1B4E7F 100%) 0% 0% no-repeat padding-box',
        opacity: 0.8,
        color: '#FFFFFF',
        textAlign: 'center',
    },
}))

export default useStyles
